import Section1 from './section1';
import Section2 from './section2';
import Section3 from './section3';
import Section4 from './section4';
import Home from './Home';
export default function Homefinal() {
    return (
        <>
        <Home />
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
        </>
    )
}
